module.exports = __webpack_public_path__ + "media/3.8d7612ad.mp3";